<template>
  <div>
    <v-icon
      @click="deleteData(item)"
      v-if="permissions.delete"
      small
      color="#D32F2F"
    >mdi-delete-outline</v-icon>
  </div>
</template>

<script>
export default {
  name: "RolePermissionActions",
  props: {
    item: {
      type: Object,
      required: true,
    },
    permissions: {
      type: Object,
      required: true,
    },
    areaAccess: {
      type: String,
    },
  },
  methods: {
    editData(item) {
      this.$emit("edit-data", item.id);
    },
    deleteData(item) {
      this.$emit("delete-data", item.id);
    },
    RoteAddpermissions() {
      this.$router.push(`${this.areaAccess}/${this.item.id}/permissions`)
    },
  }
}
</script>